module.exports = __webpack_public_path__ + "static/img/project_logo_vr.04ea41f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project_logo_vr.png
// module id = 751
// module chunks = 1